<template>
<!-- 园区预约 -->
  <el-dialog
    class="makeAppoint"
    title="预约参观"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="close"
  >
    <el-form :model="fromData" ref="fromData">
       <el-form-item prop="company" :rules="[{ required: true, message: '请填写企业全称，如未注册公司，可填“无”', trigger: 'blur' }]">
        <el-input placeholder="请填写企业全称，如未注册公司，可填“无”" v-model="fromData.company"></el-input>
      </el-form-item>
      <el-form-item prop="contact" :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
        <el-input placeholder="姓名" v-model="fromData.contact"></el-input>
      </el-form-item>
      <el-form-item
        prop="publish_date"
        :rules="[{ required: true, message: '请选择时间', trigger: 'blur' }]"
      >
        <el-date-picker
          style="width:100%;"
          v-model="fromData.publish_date"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptionsEnd"
          type="datetime"
          placeholder="预约时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <div class="btn" @click="submitForm('fromData')">立即预约</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    itemObj: {
      type: Object
    },
    dialogVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      fromData: {
        company:'',
        contact: "",
        publish_date: ""
      },
      pickerOptionsEnd: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 60 * 60 * 1000;
        }
      }
    };
  },
  methods: {
    // 预约提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.req();
        } else {
          return false;
        }
      });
    },
    req() {
      let params = Object.assign({}, this.fromData, {
        name: this.itemObj.name,
        code: this.itemObj.code,
        incubator: this.$route.query.incubator_id //会议室接口incubator_id，园区接口为id
      });
      this.api.reservationVisit(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message("预约成功！");
        this.close();
      });
    },
    close() {
      this.$emit("close", {
        name: "apply_pro",
        dialogVisible: false
      });
    }
  }
};
</script>

<style lang="scss">
.makeAppoint {
  .btn {
      margin: 0 auto;
    width: 400px;
    height: 50px;
    text-align: center;
    background: #4c84ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
  .el-input--small .el-input__inner{
      height: 50px;
      line-height: 50px;
  }
  .el-dialog__title {
    font-weight: bold;
    color: #343434;
    font-size: 30px;
  }
  .el-dialog__body{
      padding: 30px 40px;
  }
}
</style>